import React from "react";
import {AppField} from "../fields";
import {objects} from "@atttomyx/shared-utils";

const AdFilters = (props) => {
    const { data, onChange : onSync, formProps } = props;
    const { apps, appRenderer } = formProps;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="ad-filters">
        <div className="field">
            <AppField
                apps={apps}
                appRenderer={appRenderer}
                value={data.appId}
                onChange={(appId) => onChange("appId", appId)}
            />
        </div>
    </div>
}

export default AdFilters;
